import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { injectIntl } from 'react-intl';

import AdminUserManagement from '../../../components/SiteAdmin/AdminUserManagement';
import Loader from '../../../components/Common/Loader/Loader';

import adminUserQuery from './adminUserQuery.graphql';
import adminRolesQuery from './adminRolesQuery.graphql';
import messages from '../../../locale/messages';

import s from './AdminUser.css';
class AdminUser extends React.Component {

	static propTypes = {
		data: PropTypes.shape({
			loading: PropTypes.bool,
			getAllAdminRoles: PropTypes.array,
		})
	};

	static defaultProps = {
		data: {
			loading: true
		},
		adminRoles: {
			getAllAdminRoles: []
		}
	};

	render() {
		const { formatMessage } = this.props.intl;
		const { data: { loading, getAllAdminUsers } } = this.props;
		const { adminRoles: { getAllAdminRoles } } = this.props;

		return (
			<Loader type={"page"} show={loading}>
				<div className={s.root}>
					{!loading && <div className={s.container}>
						<div className={cx(s.heading, 'textAlignRightRTL', 'textWhite')}>
							{formatMessage(messages.manageAdminUsers)}
						</div>
						<div className={cx(s.paddingRoutesSection, s.responsiveNoPadding)}>
							<AdminUserManagement data={getAllAdminUsers} roles={getAllAdminRoles} />
						</div>
					</div>}
				</div>
			</Loader>
		)
	}

}

export default compose(
	injectIntl,
	withStyles(s),
	graphql(adminUserQuery, {
		options: {
			fetchPolicy: 'network-only'
		}
	}),
	graphql(adminRolesQuery, {
		name: 'adminRoles',
		options: {
			fetchPolicy: 'network-only',
			ssr: true
		}
	})
)(AdminUser);